import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import EvaluationHeader from "components/Evaluation/EvaluationHeader";
import GiveFeedback from "components/Evaluation/GiveFeedback";
import PerformanceRatings from "components/Evaluation/PerformanceRatings";
import EvaluationForm from "components/Evaluation/EvaluationForm";
import { useParams } from "react-router-dom";
import { useGetReviews } from "hooks/queries/useGetReviews";
import fetchApi from "api/fetchApi";
import IGoal from "models/Goal";

const Evaluation = () => {
  const { id } = useParams();
  const { reviews } = useGetReviews();
  const review = reviews?.find((review) => review.id === id);

  const [goals, setGoals] = useState<IGoal[]>([]);

  useEffect(() => {
    const getGoals = async () => {
      try {
        const response = await fetchApi(`users/kpis`).get(`/${review.user_id}`);
        setGoals(response.data.items);
      } catch (error) {
        console.error("Error fetching Goals", error);
      }
    };
    getGoals();
  }, [review]);

  return (
    <Box display="flex" flexDirection="column">
      <EvaluationHeader review={review} />
      <GiveFeedback />
      <PerformanceRatings />
      <EvaluationForm review={review} goals={goals} />
    </Box>
  );
};

export default Evaluation;
